import { ref } from 'vue';

// Module-level singletons so any caller (e.g. useTransactAuth) can control the
// same picker UI and await the user's chosen method via an `open()` Promise.
const isOpen = ref(false);
const options = ref({
  reason: '',
  methods: [],
  biometryLabel: '',
});

let resolveFn = null;

export function useAuthMethodPicker() {
  function open(payload = {}) {
    const current = resolveFn;
    if (current) current(null);

    options.value = {
      reason: payload.reason || '',
      methods: Array.isArray(payload.methods) ? payload.methods : [],
      biometryLabel: payload.biometryLabel || '',
    };
    const outcome = new Promise((resolve) => {
      resolveFn = resolve;
    });
    if (!isOpen.value) isOpen.value = true;
    return outcome;
  }

  function choose(method) {
    if (!resolveFn) return;
    const resolve = resolveFn;
    resolveFn = null;
    isOpen.value = false;
    resolve(method);
  }

  function cancel() {
    if (!resolveFn) return;
    const resolve = resolveFn;
    resolveFn = null;
    isOpen.value = false;
    resolve(null);
  }

  return { isOpen, options, open, choose, cancel };
}